import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IUserRepository } from '../../repositories/interfaces/iUserRepository';
import { CSRFTokenRequest, IPaymentSwitchGenerateParams } from '../../../entity';

export interface IPaymentSwitchGenerateUseCase {
    execute(payload: IPaymentSwitchGenerateParams, csrfToken: CSRFTokenRequest): Promise<any>;
}

export class PaymentSwitchGenerateUseCase implements IPaymentSwitchGenerateUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get userRepo(): IUserRepository {
        return container.resolve<IUserRepository>(DI.REPOSITORIES.IUserRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(payload: IPaymentSwitchGenerateParams, csrfToken: CSRFTokenRequest): Promise<any> {
        return await this.userRepo.paymentSwitchGenerate(payload, csrfToken);
    }
}
